import { useSetPlayerStoreData } from '../hooks'
import { playerStoreKeys } from '../playerStoreConstants'

export const useSetGeolocationStatus = () => {
  const { setPlayerStoreData } = useSetPlayerStoreData()

  const setGeolocationStatus = data => {
    setPlayerStoreData(
      {
        [playerStoreKeys.geolocationStatus]: {
          geolocationCheckComplete: data.checkComplete,
          xpointCheckInProgress: data.xPointCheckInProgress,
          geolocationClassicBrandBlockedStatus: data.classicBlocked,
          geolocationSweepsBrandBlockedStatus: data.sweepsBlocked,
          geolocationClassicErrors: data.classicErrors,
          geolocationSweepsErrors: data.sweepsErrors
        }
      },
      'setGeolocationStatus'
    )
  }

  return { setGeolocationStatus }
}
